import React, { useEffect, useState } from "react";

import { Row, Typography, Col, Divider, Card, Table, Button } from "antd";
import { TrendingUpDown } from "lucide-react";

import { FONT } from "constants/index";

import { ColumnsLastReview } from "./columns-table";
import DrawerApp from "components/drawer-app";
import ExempleCycle from "./planning-drawer-exemple-cycle";

const { Text } = Typography;
const columsExemple = [
  {
    title: "Ciclo",
    dataIndex: "cycle",
    textWrap: "word-break",
    ellipsis: true,
    width: "30%",
  },
  {
    title: "% de 1RM",
    dataIndex: "rm",
    textWrap: "word-break",
    ellipsis: true,
    width: "30%",
  },
  {
    title: "RIR",
    dataIndex: "rir",
    textWrap: "word-break",
    ellipsis: true,
    width: "30%",
  },
  {
    title: "Repetições",
    dataIndex: "repeat",
    textWrap: "word-break",
    ellipsis: true,
    width: "30%",
  },
];
const FormNewUserPlanningHangClean = (props) => {
  const [review, setReview] = useState(null);
  const [openExemple, setOpenExemple] = useState(false);

  useEffect(() => {
    setReview(props.review);
  }, [props]);

  function mountPrediction() {
    if (
      review?.actualReview == null ||
      review?.actualReview.slopeClean == null ||
      review?.actualReview?.interceptClean == null
    ) {
      return [];
    }
    const absoluteStrength = review?.actualReview?.absoluteStrengthClean;
    const slope = review?.actualReview?.slopeClean;
    const intercept = review?.actualReview?.interceptClean;

    const response = [];
    var valueInitial = 55;
    for (let index = 0; index < 9; index++) {
      const abValue = ((valueInitial * absoluteStrength) / 100).toFixed(0);
      const vmp = (slope * valueInitial + intercept).toFixed(2);
      response.push({
        absoluteStrength: abValue,
        vmp: vmp,
        rm: valueInitial,
      });
      valueInitial += 5;
    }
    return response;
  }
  const showDrawer = () => {
    setOpenExemple(true);
  };

  return (
    <>
      <Divider />

      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col span={24} style={{ textAlign: "left" }}>
          <Text
            style={{
              fontSize: "15px",
              fontFamily: FONT,
            }}
          >
            Força Absoluta:
          </Text>
          <Text
            style={{
              fontSize: "15px",
              fontFamily: FONT,
              fontWeight: "bold",
            }}
          >
            {review?.actualReview?.absoluteStrengthClean &&
              " " + review?.actualReview?.absoluteStrengthClean + "  KG"}
          </Text>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col span={outerWidth < 501 ? 24 : 24} style={{ marginTop: "10px" }}>
          <Card
            id="card-table"
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: 1 }}>
                  <TrendingUpDown
                    size={18}
                    style={{ marginBottom: "-4px", marginRight: "10px" }}
                  />
                  <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                    Valores de Predição
                  </Text>
                </div>
              </div>
            }
            bordered={false}
          >
            <Table
              columns={ColumnsLastReview("HANG_CLEAN")}
              dataSource={mountPrediction()}
              pagination={false}
              size="small"
              locale={{
                emptyText: "Sem registro",
              }}
              scroll={{
                y: 413,
              }}
            />
          </Card>
        </Col>
      </Row>
      <Row style={{ margin: 30 }} justify="end">
        <Button
          style={{
            fontFamily: FONT,
            background: "#14B8A6",
            color: "#ffffff",
          }}
          onClick={() => showDrawer(true)}
        >
          Ciclos de Exemplo
        </Button>
      </Row>
      <DrawerApp
        open={openExemple}
        onClose={() => setOpenExemple(false)}
        title={"Ciclos de Exemplo"}
        body={
          <>
            <ExempleCycle
              title={"Etapa 1 - Técnica e Adaptação (60 70%)"}
              columns={columsExemple}
              data={[
                { cycle: "1.0", rm: "60%", rir: "2", repeat: "4-6" },
                { cycle: "2.0", rm: "62%", rir: "2", repeat: "4-6" },
                { cycle: "3.0", rm: "64%", rir: "2", repeat: "4-6" },
                { cycle: "4.0", rm: "66%", rir: "2", repeat: "4-6" },
                { cycle: "5.0", rm: "68%", rir: "2", repeat: "4-6" },
                { cycle: "6.0", rm: "69%", rir: "2", repeat: "4-6" },
                { cycle: "7.0", rm: "70%", rir: "2", repeat: "4-6" },
              ]}
            />
            <ExempleCycle
              title={"Etapa 2 - Intensificação (73 82%)"}
              columns={columsExemple}
              data={[
                { cycle: "1.0", rm: "73%", rir: "2", repeat: "4-5" },
                { cycle: "2.0", rm: "75%", rir: "2", repeat: "4-5" },
                { cycle: "3.0", rm: "77%", rir: "1-2", repeat: "3-5" },
                { cycle: "4.0", rm: "79%", rir: "1-2", repeat: "3-4" },
                { cycle: "5.0", rm: "80%", rir: "1-2", repeat: "3-4" },
                { cycle: "6.0", rm: "81%", rir: "1-2", repeat: "3-4" },
                { cycle: "7.0", rm: "82%", rir: "1-2", repeat: "3-4" },
              ]}
            />
            <ExempleCycle
              title={"Etapa 3 - Alta Intensidade (84 90%)"}
              columns={columsExemple}
              data={[
                { cycle: "1.0", rm: "84%", rir: "1", repeat: "2-3" },
                { cycle: "2.0", rm: "85%", rir: "1", repeat: "2-3" },
                { cycle: "3.0", rm: "86%", rir: "1", repeat: "2" },
                { cycle: "4.0", rm: "87%", rir: "1", repeat: "2" },
                { cycle: "5.0", rm: "88%", rir: "1", repeat: "1-2" },
                { cycle: "6.0", rm: "89%", rir: "1", repeat: "1-2" },
                { cycle: "7.0", rm: "90%", rir: "1", repeat: "1-2" },
              ]}
            />
          </>
        }
        size={"large"}
        isOnlyView={true}
        width={outerWidth < 501 ? "100%" : "60%"}
      />
    </>
  );
};
export default FormNewUserPlanningHangClean;
